import {TabPanel, TabView} from 'primereact/tabview';
import React from 'react';
import {withTranslation} from 'react-i18next';
import DriverList from './DriverList';
import TrailerList from './TrailerList';
import VehicleList from './VehicleList';
class DriverVehicleList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
        };
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleTabChange(e) {
        this.setState(
            {
                activeIndex: e.index,
            },
            () => {
                this.saveCookie(`drivers-vehicles-list-activeIndex`, this.state.activeIndex);
            }
        );
    }
    readCookie(cookieName) {
        return sessionStorage.getItem(cookieName);
    }
    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }
    componentDidMount() {
        let activeIndex = this.readCookie(`drivers-vehicles-list-activeIndex`);
        if (activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        this.setState({activeIndex: parseInt(activeIndex)});
    }
    render() {
        const {t} = this.props;
        return (
            <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange}>
                <TabPanel header={t('driver-vehicle.driversHeader')} key={`driver-list-${this.state.activeIndex}`}>
                    <DriverList />
                </TabPanel>
                <TabPanel header={t('driver-vehicle.vehiclesHeader')} key={`vehicle-list-${this.state.activeIndex}`}>
                    <VehicleList />
                </TabPanel>
                <TabPanel header={t('driver-vehicle.trailersSemitrailersHeader')} key={`trailer-list-${this.state.activeIndex}`}>
                    <TrailerList />
                </TabPanel>
            </TabView>
        );
    }
}
export default withTranslation()(DriverVehicleList);
